import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-chat-new-dialog',
  templateUrl: './chat-new-dialog.component.html',
  styleUrls: ['./chat-new-dialog.component.scss']
})
export class ChatNewDialogComponent implements OnInit {

  data: any[];
  filteredData: any[];
  searchQuery: string = '';

  constructor(
    public dialogRef: MatDialogRef<ChatNewDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public inputData: any,
  ) {
    this.data = inputData;
    this.filteredData = this.data;
  }

  ngOnInit(): void {
  }

  closePopUp() {
    this.dialogRef.close();
  }

  openChat(e: any) {
    this.dialogRef.close(e);
  }

  filterChats() {
    if (!this.searchQuery) {
      this.filteredData = this.data;
    } else {
      const query = this.searchQuery.toLowerCase();
      this.filteredData = this.data.filter(chat =>
        chat.fullName.toLowerCase().includes(query) ||
        chat.company.name.toLowerCase().includes(query) ||
        chat.userType.toLowerCase().includes(query)
      );
    }
  }
}
